import { render, staticRenderFns } from "./attorney-inspection-reports-received.vue?vue&type=template&id=6551997a"
import script from "./attorney-inspection-reports-received.vue?vue&type=script&lang=js"
export * from "./attorney-inspection-reports-received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports